import { useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/hooks/use-toast";
import { Mail } from "lucide-react";

export const NewsletterForm = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    const { error } = await supabase.from("email_subscribers").insert({ email });
    if (error) {
      if (error.code === "23505") {
        toast({ 
          title: t("sections.alreadySubscribed"), 
          description: t("sections.alreadySubscribedDesc") 
        });
      } else {
        toast({ title: t("common.error"), description: error.message, variant: "destructive" });
      }
    } else {
      toast({ 
        title: t("sections.subscribedSuccess"), 
        description: t("sections.subscribedSuccessDesc") 
      });
      setEmail("");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2 max-w-md">
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          type="email"
          placeholder={t("sections.emailPlaceholder")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="pl-10"
          required
        />
      </div>
      <Button type="submit" disabled={loading} className="whitespace-nowrap px-6">
        {loading ? "..." : t("sections.subscribeButton")}
      </Button>
    </form>
  );
};
